import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("revive_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};
